<template>
    <div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <!-- <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormFolios" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th :class="StyleTh+' text-center'">#</th>
                                                    <th :class="StyleTh">Folio de:</th>
                                                    <th :class="StyleTh">Serie</th>
                                                    <th :class="StyleTh">Numeración</th>
                                                    <th :class="StyleTh+' text-center'">Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                                                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                                                    <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                                    <td><p :class="StyleTd">{{lista.Serie}}</p></td>
                                                    <td><p :class="StyleTd">{{lista.Numero}}</p></td>
                                
                                                    <td class="align-middle text-end">
                                                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdFolio" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                                                            <template slot="btnaccion">
                                                            </template>
                                                        </CBtnAccion>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br>
                                        <CBtnSave :poBtnSave="oBtnSave2" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template> -->
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio de:</th>
                <th :class="StyleTh">Serie</th>
                <th :class="StyleTh">Numeración</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Serie}}</p></td>
                    <td><p :class="StyleTd">{{lista.Numero}}</p></td>

					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdFolio" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="5"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :ListaFiltro="ListaArrayRows" :TiposFolio="TiposFolio" :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>
<script>
import moment from 'moment';
import Form from '@/views/catalogos/folio/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionFolio';
const EmitEjecuta2 = 'seccionFolios';

export default {
    name: 'ListaFolio',
    props: ['sFiltros','pOrigen'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Folio',
                IsModal: true,
                ShowLoader:true,
                /*ShowYear: true,*/
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Configuración',
                ShowFiltros:    false,
                ShowSearch:     false,
                ShowEntradas:   false,
                ShowPaginador:  false,
                // TypeBody:'Form'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario Folio",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                TxtBtnSave:'Añadir Folio',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                // TxtBtnSave:'Añadir Folio',
                EmitSeccion: EmitEjecuta2,
                ShowBtnCancel:false,
            },
            ConfigLoad:{
                ShowLoader:true
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            
            TiposFolio:[]
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;
            // this.ConfigLoad.ShowLoader = true;

            await this.$http.get("folio",{
                // params:{
                //     TxtBusqueda: this.Filtro.Nombre,
                //     Entrada: this.Filtro.Entrada,
                //     Pag: this.Filtro.Pagina,
                // }
            }).then((res) => {
                // this.Filtro.Pagina      = res.data.data.current_page;
                // this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                // this.ConfigLoad.ShowLoader = false;
                this.ConfigList.ShowLoader = false;
                this.RecuperarTiposFolio();
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('folio/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        // PROPIOS
        RecuperarTiposFolio(){
            this.$http.get("tipofolio").then((res)=>{
                this.TiposFolio=res.data.data;
            })
            // .finally(()=>{
            //     this.ConfigList.ShowLoader=false;
            // })
        }
    },
    created()
    {
        // if(this.pOrigen != undefined){
        //     sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        // }

        // let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        // if(Origen){
        //     this.ConfigList.TitleFirst = Origen;
        // }
        // else{
        //     this.ConfigList.ShowTitleFirst = false;
        // }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
        this.bus.$off('AniadirFolio');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
        this.bus.$on('AniadirFolio',(Folio)=>
        {
            this.ListaArrayRows.push(Folio);
        });
    }
}
</script>